// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"401e1904","262":"eaadb99e","453":"871f3200","626":"0a5c3cb1"}[chunkId] + ".chunk.js";
};